import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { alpha, useTheme } from "@mui/material/styles";
const IllustrationTabButton = ({ tab, index, selectedIndex, uid, isTablistVertical, ...tabProps }) => {
    const isSelected = selectedIndex === index;
    const theme = useTheme();
    const activeBorderColor = tab.borderColor || theme.palette.primary.main;
    const inactiveBorderColor = theme.palette.border?.grey || "#E2E2E9";
    const hoverBorderColor = alpha(activeBorderColor, 0.4);
    return (_jsx(Tab, { ...tabProps, id: `${uid}-tab-${index}`, "aria-controls": `${uid}-tabpanel-${index}`, disableRipple: true, label: _jsxs(Stack, { spacing: 1, sx: {
                width: "100%",
                alignItems: "flex-start",
            }, children: [tab.icon?.url && (_jsx(Box, { component: "img", src: tab.icon.url, alt: "", sx: { display: "block", height: 48, width: "auto" } })), _jsx(Typography, { variant: "subtitle1", component: "span", sx: {
                        whiteSpace: "normal",
                        color: "text.primary",
                        fontSize: { xs: 12, md: isTablistVertical ? 16 : 14 },
                        lineHeight: 1.3,
                    }, children: tab.label })] }), sx: {
            position: "relative",
            overflow: "visible",
            // MUI applique opacity:0.6 par défaut aux onglets non sélectionnés
            opacity: 1,
            alignItems: "flex-start",
            textAlign: "left",
            px: {
                xs: 2.5,
                md: isTablistVertical ? 3.5 : 4,
            },
            py: {
                xs: 1.5,
                md: isTablistVertical ? 3.5 : 2,
            },
            minHeight: { xs: 72, md: 88 },
            width: { xs: 130, md: "100%" },
            transition: "background-color 150ms ease, border-color 150ms ease",
            ...(isTablistVertical
                ? { borderLeft: "3px solid transparent" }
                : { borderBottom: "3px solid transparent" }),
            backgroundColor: isSelected ? "background.default" : "transparent",
            borderColor: isSelected ? activeBorderColor : inactiveBorderColor,
            ...(!isSelected && {
                "&:hover": {
                    cursor: "pointer",
                    borderColor: hoverBorderColor,
                    backgroundColor: alpha(theme.palette.common.white, 0.6),
                },
            }),
        } }));
};
export default IllustrationTabButton;
